function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
document.addEventListener('DOMContentLoaded', function () {
    var dropdown = document.querySelector('.navbar .dropdown');
    var subnav = document.querySelector('.navbar__scrollable .navbar__nav');
    var navbarArrowLeft = document.querySelector('.navbar__arrow--left');
    var navbarArrowRight = document.querySelector('.navbar__arrow--right');
    var seriesElement = Array.from(subnav.querySelectorAll('.nav__item'));
    var isLoaded = false;
    var series = [];
    var Accordion = /*#__PURE__*/function () {
        function Accordion(accordionContainer) {
            var _this = this;
            _classCallCheck(this, Accordion);
            this.items = [];
            var accordionItems = Array.from(accordionContainer.querySelectorAll("[data-accordion-item]"));
            if (accordionItems.length === 0) {
                //Covers the case when there is only one accordion item. The accordion container is the accordion item.
                accordionItems = [accordionContainer];
            }
            this.items = accordionItems.map(function (item) {
                return new AccordionItem(item, _this);
            });
        }

        /**
         * Folds all the accordion items except the one passed as a parameter.
         *
         * @param {AccordionItem} exception The accordion item that will not be folded.
         */
        _createClass(Accordion, [{
            key: "closeItems",
            value: function closeItems(exception) {
                this.items.forEach(function (accordion) {
                    if (accordion !== exception) {
                        accordion.close();
                    }
                });
            }
        }]);
        return Accordion;
    }();
    var AccordionItem = /*#__PURE__*/function () {
        function AccordionItem(element, parent) {
            _classCallCheck(this, AccordionItem);
            this.element = element;
            this.isOpen = false;
            this.parent = parent;
            this.body = this.element.querySelector("[data-accordion-body]");
            this.height = getComputedStyle(this.body).getPropertyValue('--max-height');
            if (element.classList.contains("is-open")) {
                this.open(false);
            }
            element.addEventListener("click", this.handleClick.bind(this));
        }

        /**
         * Handles a click on this accordion.
         */
        _createClass(AccordionItem, [{
            key: "handleClick",
            value: function handleClick(event) {
                var target = event.target;
                if (target.closest("[data-accordion-item] > a[role='button']")) {
                    event.preventDefault();
                }
                if (target.closest("[data-accordion-body]")) {
                    return;
                }
                if (!this.isOpen) {
                    this.open();
                } else {
                    this.close();
                }
            }

            /**
             * Unfolds this accordion item and folds the rest of the accordion items
             *
             * @param {Boolean} doTransition Whether the accordion item should be opened doing a transition.
             */
        }, {
            key: "open",
            value: function open() {
                var doTransition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                if (!this.isOpen) {
                    if (!doTransition) {
                        this.body.style.transition = "none";
                    }
                    this.body.style.maxHeight = this.height;
                    this.isOpen = true;
                    this.element.classList.add("is-open");
                    this.parent.closeItems(this);
                    if (!doTransition) {
                        this.body.offsetHeight;
                        this.body.style.transition = "";
                    }
                }
            }

            /**
             * Folds this accordion item.
             */
        }, {
            key: "close",
            value: function close() {
                if (this.isOpen) {
                    this.body.style.maxHeight = "0px";
                    this.isOpen = false;
                    this.element.classList.remove("is-open");
                }
            }
        }]);
        return AccordionItem;
    }();
    var toggleOpen = function toggleOpen() {
        function hideOnClickOutside(element) {
            var outsideClickListener = function outsideClickListener(event) {
                if (!element.contains(event.target) && isVisible(element)) {
                    dropdown.classList.remove('is-open');
                    dropdown.querySelector('.dropdown__toggle').classList.remove('is-active');
                    removeClickListener();
                }
            };
            var removeClickListener = function removeClickListener() {
                document.removeEventListener('click', outsideClickListener);
            };
            document.addEventListener('click', outsideClickListener);
        }
        var isVisible = function isVisible(elem) {
            return !!elem && !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
        };
        dropdown.classList.toggle('is-open');
        dropdown.querySelector('.dropdown__toggle').classList.toggle('is-active');
        hideOnClickOutside(dropdown.querySelector('.dropdown__menu'));
    };
    var isOverflown = function isOverflown(_ref) {
        var clientWidth = _ref.clientWidth,
            scrollWidth = _ref.scrollWidth;
        return scrollWidth > clientWidth;
    };
    var checkSubnavOverflow = function checkSubnavOverflow() {
        var width = window.innerWidth;
        if (width >= 1188 && isOverflown(subnav)) {
            subnav.closest('.navbar__scrollable').classList.add('has-overflow');
        } else {
            subnav.closest('.navbar__scrollable').classList.remove('has-overflow');
        }
    };
    var scrollToSerie = function scrollToSerie(direction) {
        if (direction === 'left') {
            var currentIndex = series.findIndex(function (serie) {
                return serie.isIntersecting === true;
            });
            var previousIndex = currentIndex - 1;
            if (previousIndex >= 0) {
                var previousItem = series.find(function (serie) {
                    return serie.id === previousIndex;
                });
                previousItem.target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'end'
                });
            }
        } else if (direction === 'right') {
            var _currentIndex = series.slice().reverse().findIndex(function (serie) {
                return serie.isIntersecting === true;
            });
            if (_currentIndex !== -1) {
                _currentIndex = series.length - 1 - _currentIndex;
            }
            var nextIndex = _currentIndex + 1;
            if (nextIndex < series.length) {
                var nextItem = series.find(function (serie) {
                    return serie.id === nextIndex;
                });
                nextItem.target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'start'
                });
            }
        }
    };
    var setSeries = function setSeries(series) {
        return series.map(function (serie, index) {
            var target = serie.target,
                isVisible = serie.isVisible,
                isIntersecting = serie.isIntersecting;
            return {
                'id': index,
                'target': target,
                'isVisible': isVisible,
                'isIntersecting': isIntersecting
            };
        });
    };
    var updateSeries = function updateSeries(newSerie) {
        return series.map(function (serie) {
            var target = newSerie.target,
                isVisible = newSerie.isVisible,
                isIntersecting = newSerie.isIntersecting;
            return target === serie.target ? _objectSpread(_objectSpread({}, serie), {}, {
                'isVisible': isVisible,
                'isIntersecting': isIntersecting
            }) : serie;
        });
    };
    var setActiveSerie = function setActiveSerie() {
        var currentSerie = series.find(function (serie) {
            return serie && serie.target.children[0].classList.contains('is-active');
        });
        if (currentSerie) {
            currentSerie.target.scrollIntoView({
                behavior: 'instant',
                block: 'nearest',
                inline: 'start'
            });
        }
    };
    var observer = new IntersectionObserver(function (entries) {
        if (!isLoaded) {
            series = setSeries(entries);
            setActiveSerie();
            isLoaded = true;
            return;
        }
        entries.forEach(function (entry) {
            series = updateSeries(entry);
        });
    }, {
        threshold: 1.0
    });
    var addEventListeners = function addEventListeners() {
        if (dropdown) {
            dropdown.querySelector('.dropdown__toggle').addEventListener('click', function (event) {
                event.stopPropagation();
                toggleOpen();
            });
        }
        if (navbarArrowRight) {
            navbarArrowRight.addEventListener('click', function () {
                return scrollToSerie('right');
            });
        }
        if (navbarArrowLeft) {
            navbarArrowLeft.addEventListener('click', function () {
                return scrollToSerie('left');
            });
        }
        window.addEventListener('resize', checkSubnavOverflow);
        seriesElement.forEach(function (serieElement) {
            return observer.observe(serieElement);
        });
        document.querySelectorAll('[data-accordion]').forEach(function (accordion) {
            return new Accordion(accordion);
        });
    };
    checkSubnavOverflow();
    addEventListeners();
});



// document.addEventListener('DOMContentLoaded', () => {
//     const dropdown = document.querySelector('.navbar .dropdown');
//     const subnav = document.querySelector('.navbar__scrollable .navbar__nav');
//     const navbarArrowLeft = document.querySelector('.navbar__arrow--left');
//     const navbarArrowRight = document.querySelector('.navbar__arrow--right');
//     const seriesElement = Array.from(subnav.querySelectorAll('.nav__item'));
//     let isLoaded = false;
//     let series = [];
//
//     class Accordion {
//         constructor(accordionContainer) {
//             this.items = [];
//
//             let accordionItems = Array.from(accordionContainer.querySelectorAll("[data-accordion-item]"));
//             if (accordionItems.length === 0) {
//                 //Covers the case when there is only one accordion item. The accordion container is the accordion item.
//                 accordionItems = [accordionContainer];
//             }
//
//             this.items = accordionItems.map((item) => {
//                 return new AccordionItem(item, this);
//             });
//         }
//
//         /**
//          * Folds all the accordion items except the one passed as a parameter.
//          *
//          * @param {AccordionItem} exception The accordion item that will not be folded.
//          */
//         closeItems(exception) {
//             this.items.forEach((accordion) => {
//                 if (accordion !== exception) {
//                     accordion.close();
//                 }
//             });
//         }
//     }
//
//     class AccordionItem {
//         constructor(element, parent) {
//             this.element = element;
//             this.isOpen = false;
//             this.parent = parent;
//             this.body = this.element.querySelector("[data-accordion-body]");
//             this.height = getComputedStyle(this.body).getPropertyValue('--max-height');
//
//             if (element.classList.contains("is-open")) {
//                 this.open(false);
//             }
//
//             element.addEventListener("click", this.handleClick.bind(this));
//         }
//
//         /**
//          * Handles a click on this accordion.
//          */
//         handleClick(event) {
//             event.preventDefault();
//
//             const target = event.target;
//             if (target.closest("[data-accordion-body]")) {
//                 return;
//             }
//
//             if (!this.isOpen) {
//                 this.open();
//             } else {
//                 this.close();
//             }
//         }
//
//         /**
//          * Unfolds this accordion item and folds the rest of the accordion items
//          *
//          * @param {Boolean} doTransition Whether the accordion item should be opened doing a transition.
//          */
//         open(doTransition = true) {
//             if (!this.isOpen) {
//                 if (!doTransition) {
//                     this.body.style.transition = "none";
//                 }
//                 this.body.style.maxHeight = this.height;
//                 this.isOpen = true;
//                 this.element.classList.add("is-open");
//                 this.parent.closeItems(this);
//                 if (!doTransition) {
//                     this.body.offsetHeight;
//                     this.body.style.transition = "";
//                 }
//             }
//         }
//
//         /**
//          * Folds this accordion item.
//          */
//         close() {
//             if (this.isOpen) {
//                 this.body.style.maxHeight = "0px";
//                 this.isOpen = false;
//                 this.element.classList.remove("is-open");
//             }
//         }
//     }
//
//     const toggleOpen = () => {
//         dropdown.classList.toggle('is-open');
//         dropdown.querySelector('.dropdown__toggle').classList.toggle('is-active');
//     }
//
//     const isOverflown = ({ clientWidth, scrollWidth }) => scrollWidth > clientWidth;
//
//     const checkSubnavOverflow = () => {
//         const width = window.innerWidth;
//
//         if (width >= 1188 && isOverflown(subnav)) {
//             subnav.closest('.navbar__scrollable').classList.add('has-overflow');
//         } else {
//             subnav.closest('.navbar__scrollable').classList.remove('has-overflow');
//         }
//     }
//
//     const scrollToSerie = (direction) => {
//         if (direction === 'left') {
//             const currentIndex = series.findIndex(serie => serie.isIntersecting === true);
//             const previousIndex = currentIndex - 1;
//
//             if (previousIndex >= 0) {
//                 const previousItem = series.find(serie => serie.id === previousIndex);
//                 previousItem.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
//             }
//         } else if (direction === 'right') {
//             const currentIndex = series.findLastIndex(serie => serie.isIntersecting === true);
//             const nextIndex = currentIndex + 1;
//
//             if (nextIndex < series.length) {
//                 const nextItem = series.find(serie => serie.id === nextIndex);
//                 nextItem.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'end' });
//             }
//         }
//     }
//
//     const setSeries = (series) => {
//         return series.map((serie, index) => {
//             const {target, isVisible, isIntersecting} = serie;
//
//             return {
//                 'id': index,
//                 'target': target,
//                 'isVisible': isVisible,
//                 'isIntersecting': isIntersecting
//             }
//         });
//     }
//
//     const updateSeries = (newSerie) => {
//         return series.map((serie) => {
//             const {target, isVisible, isIntersecting} = newSerie;
//
//             return target === serie.target
//             ? {
//                   ...serie,
//                   'isVisible': isVisible,
//                   'isIntersecting': isIntersecting,
//               }
//             : serie
//         });
//     }
//
//     const observer = new IntersectionObserver((entries) => {
//         if (!isLoaded) {
//             series = setSeries(entries);
//             isLoaded = true;
//             return
//         }
//
//         entries.forEach(entry => {
//             series = updateSeries(entry);
//         });
//     }, {
//         threshold: .75,
//     });
//
//     const addEventListeners = () => {
//         dropdown.addEventListener('click', toggleOpen);
//         navbarArrowRight.addEventListener('click', () => scrollToSerie('right'));
//         navbarArrowLeft.addEventListener('click', () => scrollToSerie('left'));
//         window.addEventListener('resize', checkSubnavOverflow);
//         seriesElement.forEach(serieElement => observer.observe(serieElement));
//         document.querySelectorAll('[data-accordion]').forEach((accordion) => new Accordion(accordion));
//     }
//
//     checkSubnavOverflow();
//     addEventListeners();
// });